import { WithTranslation } from 'react-i18next';

export const getConfirmationTypeHelpText = (
  confirmationType: 'REQUEST' | 'INSTANT' | 'REJECT' | null,
  availabilityReason:
    | 'CLOSED'
    | 'EXCEED_DEADLINE'
    | 'NO_ALLOTMENT'
    | 'NO_MIN_PAX'
    | 'NO_RESOURCE'
    | 'PARTICIPATION_DATE_NOT_SELECTED'
    | null,
  t: WithTranslation['t']
) => {
  switch (confirmationType) {
    case 'REQUEST':
      return t('Request-only bookings require explicit confirmation from supplier');
    case 'INSTANT':
      return t('Instant bookings will be confirmed automatically within seconds of submission');
    case 'REJECT':
      if (availabilityReason === 'NO_ALLOTMENT' || availabilityReason === 'NO_RESOURCE') {
        return t(
          'Sorry, we do not have enough availability for the selected date and time. Please try on different date'
        );
      } else if (availabilityReason === 'PARTICIPATION_DATE_NOT_SELECTED') {
        return t(
          'To apply for this plan, please select the participation date and time individually.'
        );
      } else {
        return t('Sales for the selected date and time have been suspended');
      }
    default:
      return '';
  }
};
